(() => {
  if (window.lomaVistaMastodonVideoLoaded) return;
  window.lomaVistaMastodonVideoLoaded = true;

  const films = new Map();
  let activeFilm;

  function stop(film) {
    film.video.pause();
    if (activeFilm !== film) return;
    activeFilm = undefined;
    document.documentElement.classList.remove('mastodon-film-open');
    if (film.trigger.isConnected) film.trigger.focus({ preventScroll: true });
  }

  function initialize() {
    document.querySelectorAll('[data-mastodon-film]').forEach(root => {
      if (films.has(root)) return;
      const trigger = root.querySelector('[data-mastodon-film-open]');
      const dialog = root.querySelector('[data-mastodon-film-dialog]');
      const video = dialog?.querySelector('video');
      if (!trigger || !video || typeof dialog.showModal !== 'function') return;
      const film = { root, trigger, dialog, video };
      films.set(root, film);
      dialog.addEventListener('close', () => stop(film));
      dialog.addEventListener('cancel', () => stop(film));
      video.addEventListener('error', () => {
        // Native controls remain available; never hide a failed player behind the poster.
        video.setAttribute('aria-label', 'Video could not load. Please try again.');
      });
      trigger.disabled = false;
    });
  }

  document.addEventListener('click', event => {
    const root = event.target.closest('[data-mastodon-film]');
    const film = films.get(root);
    if (!film) return;
    if (event.target.closest('[data-mastodon-film-open]')) {
      if (film.dialog.open) return;
      if (activeFilm) activeFilm.dialog.close();
      activeFilm = film;
      film.dialog.showModal();
      document.documentElement.classList.add('mastodon-film-open');
      // The visitor's click requests playback. iOS may still require its native Play control.
      film.video.play()?.catch(() => {});
    } else if (event.target.closest('[data-mastodon-film-close]')) {
      film.dialog.close();
      stop(film);
    } else if (event.target === film.dialog) {
      const bounds = film.dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        film.dialog.close();
        stop(film);
      }
    }
  });

  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    films.forEach((film, root) => {
      if (!event.target.contains(root)) return;
      film.dialog.close();
      stop(film);
      films.delete(root);
    });
  });
  window.addEventListener('pagehide', () => {
    if (!activeFilm) return;
    const film = activeFilm;
    film.dialog.close();
    stop(film);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
